import { CURRENT_USER } from "src/constants";
import { AccessByRole, AccessPerPage } from "src/models/access.model";
import { User } from "src/models/user.model";
import { jwt } from "./jwt";
import { MyJWTUser } from "src/models/Login.Model";

export function userHasAccessToPage(functionnality: string) {
  // const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER)) || null;
  const userData: MyJWTUser | null = jwt.decodeToken() as MyJWTUser | null;
  const profileNumber = Number(userData.IdProfile);
  if (userData === null) return false;
  
  if(functionnality === AccessPerPage.Standar){
    return true
  }
  if(functionnality === AccessPerPage.CDR){
    return (profileNumber !== 3 && profileNumber !== 8);
  }
  if (functionnality === AccessPerPage.menu) {
    return (profileNumber ===2 || profileNumber ===5);  // Admin, et Marketing
  }

  return false;
}

export function userHasPermission(functionnality: string) {
  // const userData2: User = JSON.parse(localStorage.getItem(CURRENT_USER)) || null;
    const userData: MyJWTUser | null = jwt.decodeToken() as MyJWTUser | null;
  const profileNumber = Number(userData.IdProfile);
  if (userData === null) return false;
  // Modele
  if (functionnality === AccessByRole.writeModele) {
    return (profileNumber !== 4 && profileNumber !== 2 && profileNumber != 5 );  // CDR 
  }
  if (functionnality === AccessByRole.UpdateTrigramme) {
    return (profileNumber === 1 || profileNumber === 2 || profileNumber == 5);  // Tout sauf direction et support
  }
  if (functionnality === AccessByRole.AccesMKT_Admin) {
    return (profileNumber === 2 || profileNumber === 5);  // Tout sauf direction et support
  }
  if (functionnality === AccessByRole.isContry_France) {
    return (userData.Pays === "France" || profileNumber === 5);  // Tout sauf direction et support
  }
  
  return false;
}